
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.715 8c1.151 0 2-.849 2-2s-.849-2-2-2-2 .849-2 2 .848 2 2 2zM16 5h-4v2h4V5zM16 9h-3v2h3V9zM7.715 8.75c2.039 0 3.715 1.876 3.715 3.25H4c0-1.374 1.676-3.25 3.715-3.25z","fill":"#585858"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 0H2C.897 0 0 .841 0 1.875v12.25C0 15.159.897 16 2 16h16c1.103 0 2-.841 2-1.875V1.875C20 .841 19.103 0 18 0zm0 14l-16-.011V2l16 .011V14z","fill":"#585858"}})])
          )
        }
      }
    